import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-switch-lang';
import { observer } from 'mobx-react';
import Breadcrumb from '../../components/Breadcrumb';
import {
  AboutMe,
  Address,
  City, Company, Country, Delete,
  Edit,
  EmailAddress, FirstName, LastName,
  Password, PostalCode, Save, Update, UpdateProfile, Username, UsersCountryMenu, UsersTableHeader, UsersTableTitle,
  Website,
} from '../../../../../theme/theme/src/constant';
import seven from '../../../../../theme/theme/src/assets/images/user/7.jpg';
import authStorage from '../../storages/mobx/authStorage';
import Card from '../../components/Card';
import ChangeableImage from '../../components/images/ChangeableImage';
import TextInput from '../../components/forms/TextInput';

function EditProfile({ t }) {
  const data = [];
  return (
    <div>
      <Breadcrumb
        path={[
          t('global.Users'),
        ]}
        allowBack
        title={t('global.Edit Profile')}
        parent={t('global.Home')}
        actions={[
          // <AddButton id="users-newUser-button" text={t('users.New user')} className="fa-2x" />,
          // <Bookmark />,
        ]}
      />
      <div className="container-fluid">
        <div className="edit-profile">
          <div className="row">
            <div className="col-lg-4">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title mb-0">{t('profile.MyProfile')}</h4>
                  <div className="card-options">
                    <a className="card-options-collapse" href="javascript" data-toggle="card-collapse">
                      <i className="fe fe-chevron-up" />
                    </a>
                    <a className="card-options-remove" href="javascript" data-toggle="card-remove">
                      <i className="fe fe-x" />
                    </a>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row flex justify-content-center">
                    <ChangeableImage
                      opened={authStorage.profileImageUploadDialogOpened}
                      toggle={authStorage.profileImageUploadDialogToggle}
                      // onSave={authStorage.saveProfile}
                      getUploadParams={authStorage.getProfileImageUploadParams}
                      handleUpload={authStorage.handleProfileImageUpload}
                      cancelText={t('Close')}
                      saveText={t('Save')}
                      image={authStorage.avatar || seven}
                    />
                  </div>
                  <div className="row flex flex-column">
                    <TextInput
                      id="name"
                      value={authStorage.name}
                      placeholder={t('users.name')}
                      onInput={authStorage.changeField}
                    />
                    <TextInput
                      id="soname"
                      value={authStorage.soname}
                      placeholder={t('users.soname')}
                      onInput={authStorage.changeField}
                    />
                    <TextInput
                      id="surname"
                      value={authStorage.surname}
                      placeholder={t('users.surname')}
                      onInput={authStorage.changeField}
                    />
                    <TextInput
                      id="email"
                      value={authStorage.email}
                      placeholder={t('users.email')}
                      onInput={authStorage.changeField}
                      type="email"
                    />
                    <TextInput
                      id="perfectum_id"
                      value={authStorage.perfectum_id}
                      placeholder={t('users.crmId')}
                      onInput={authStorage.changeField}
                      type="number"
                    />
                  </div>
                  <div className="form-footer">
                    <button disabled={!authStorage.haveChanges} className="btn btn-primary btn-block" onClick={authStorage.saveProfile}>{t('profile.Save')}</button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <Card title={t('profile.Authorization methods')}>
                <div className="form-group">
                  <TextInput
                    id="login"
                    value={authStorage.login}
                    placeholder={t('profile.Login')}
                    onInput={authStorage.changeField}
                  />
                </div>
                <div className="form-group">
                  <TextInput
                    id="email"
                    value={authStorage.email}
                    placeholder="E-mail: your-email@domain.com"
                    onInput={authStorage.changeField}
                  />
                </div>
                <button disabled={!authStorage.haveChanges} className="btn btn-primary btn-block" onClick={authStorage.saveProfile}>{t('profile.Save')}</button>
                <button disabled={!authStorage.email} className="btn btn-primary btn-block" onClick={authStorage.sendRestoreLink}>{t('profile.Restore')}</button>
                {/* <button className="btn btn-outline-transparent">{t('profile.Add method')}</button> */}
              </Card>
              {/* <Card title={t('profile.Allowed services')}> */}
              {/*  Body */}
              {/* </Card> */}
              {/* <Card title={t('profile.Contacts')}> */}
              {/*  Body */}
              {/* </Card> */}
              {/* <form className="card"> */}
              {/*  <div className="card-header"> */}
              {/*    <h4 className="card-title mb-0">{t('global.Edit Profile')}</h4> */}
              {/*    <div className="card-options"> */}
              {/*      <a className="card-options-collapse" href="javascript" data-toggle="card-collapse"><i className="fe fe-chevron-up" /></a> */}
              {/*      <a className="card-options-remove" href="javascript" data-toggle="card-remove"><i className="fe fe-x" /></a> */}
              {/*    </div> */}
              {/*  </div> */}
              {/*  <div className="card-body"> */}
              {/*    <div className="row"> */}
              {/*      <div className="col-md-5"> */}
              {/*        <div className="form-group"> */}
              {/*          <label className="form-label">{Company}</label> */}
              {/*          <input className="form-control" type="text" placeholder="Company" /> */}
              {/*        </div> */}
              {/*      </div> */}
              {/*      <div className="col-sm-6 col-md-3"> */}
              {/*        <div className="form-group"> */}
              {/*          <label className="form-label">{Username}</label> */}
              {/*          <input className="form-control" type="text" placeholder="Username" /> */}
              {/*        </div> */}
              {/*      </div> */}
              {/*      <div className="col-sm-6 col-md-4"> */}
              {/*        <div className="form-group"> */}
              {/*          <label className="form-label">{EmailAddress}</label> */}
              {/*          <input className="form-control" type="email" placeholder="Email" /> */}
              {/*        </div> */}
              {/*      </div> */}
              {/*      <div className="col-sm-6 col-md-6"> */}
              {/*        <div className="form-group"> */}
              {/*          <label className="form-label">{FirstName}</label> */}
              {/*          <input className="form-control" type="text" placeholder="Company" /> */}
              {/*        </div> */}
              {/*      </div> */}
              {/*      <div className="col-sm-6 col-md-6"> */}
              {/*        <div className="form-group"> */}
              {/*          <label className="form-label">{LastName}</label> */}
              {/*          <input className="form-control" type="text" placeholder="Last Name" /> */}
              {/*        </div> */}
              {/*      </div> */}
              {/*      <div className="col-md-12"> */}
              {/*        <div className="form-group"> */}
              {/*          <label className="form-label">{Address}</label> */}
              {/*          <input className="form-control" type="text" placeholder="Home Address" /> */}
              {/*        </div> */}
              {/*      </div> */}
              {/*      <div className="col-sm-6 col-md-4"> */}
              {/*        <div className="form-group"> */}
              {/*          <label className="form-label">{City}</label> */}
              {/*          <input className="form-control" type="text" placeholder="City" /> */}
              {/*        </div> */}
              {/*      </div> */}
              {/*      <div className="col-sm-6 col-md-3"> */}
              {/*        <div className="form-group"> */}
              {/*          <label className="form-label">{PostalCode}</label> */}
              {/*          <input className="form-control" type="number" placeholder="ZIP Code" /> */}
              {/*        </div> */}
              {/*      </div> */}
              {/*      <div className="col-md-5"> */}
              {/*        <div className="form-group"> */}
              {/*          <label className="form-label">{Country}</label> */}
              {/*          <select className="form-control btn-square"> */}
              {/*            {UsersCountryMenu.map((items, i) => <option key={i}>{items}</option>)} */}
              {/*          </select> */}
              {/*        </div> */}
              {/*      </div> */}
              {/*      <div className="col-md-12"> */}
              {/*        <div className="form-group mb-0"> */}
              {/*          <label className="form-label">{AboutMe}</label> */}
              {/*          <textarea className="form-control" rows="5" placeholder="Enter About your description" /> */}
              {/*        </div> */}
              {/*      </div> */}
              {/*    </div> */}
              {/*  </div> */}
              {/*  <div className="card-footer text-right"> */}
              {/*    <button className="btn btn-primary" type="submit">{UpdateProfile}</button> */}
              {/*  </div> */}
              {/* </form> */}
            </div>
            {/* <div className="col-md-12"> */}
            {/*  <div className="card"> */}
            {/*    <div className="card-header"> */}
            {/*      <h4 className="card-title mb-0">{UsersTableTitle}</h4> */}
            {/*      <div className="card-options"> */}
            {/*        <a className="card-options-collapse" href="javascript" data-toggle="card-collapse"><i className="fe fe-chevron-up" /></a> */}
            {/*        <a className="card-options-remove" href="javascript" data-toggle="card-remove"><i className="fe fe-x" /></a> */}
            {/*      </div> */}
            {/*    </div> */}
            {/*    <div className="table-responsive"> */}
            {/*      <table className="table card-table table-vcenter text-nowrap"> */}
            {/*        <thead> */}
            {/*          <tr> */}
            {/*            {UsersTableHeader.map((items, i) => <th key={i}>{items}</th>)} */}
            {/*          </tr> */}
            {/*        </thead> */}
            {/*        <tbody> */}
            {/*          {data.map((items, i) => ( */}
            {/*            <tr key={i}> */}
            {/*              <td> */}
            {/*                <a className="text-inherit" href="#javascript"> */}
            {/*                  {items.projectName} */}
            {/*                  {' '} */}
            {/*                </a> */}
            {/*              </td> */}
            {/*              <td>{items.date}</td> */}
            {/*              <td> */}
            {/*                <span className="status-icon bg-success" /> */}
            {/*                {items.status} */}
            {/*              </td> */}
            {/*              <td>{items.price}</td> */}
            {/*              <td className="text-right"> */}
            {/*                <button className="btn btn-primary btn-sm" href="javascript"> */}
            {/*                  <i className="fa fa-pencil" /> */}
            {/*                  {' '} */}
            {/*                  {Edit} */}
            {/*                </button> */}
            {/*                <button className="btn btn-transparent btn-sm" href="javascript"> */}
            {/*                  <i className="fa fa-link" /> */}
            {/*                  {' '} */}
            {/*                  {Update} */}
            {/*                </button> */}
            {/*                <button className="btn btn-danger btn-sm" href="javascript"> */}
            {/*                  <i className="fa fa-trash" /> */}
            {/*                  {' '} */}
            {/*                  {Delete} */}
            {/*                </button> */}
            {/*              </td> */}
            {/*            </tr> */}
            {/*          ))} */}
            {/*        </tbody> */}
            {/*      </table> */}
            {/*    </div> */}
            {/*  </div> */}
            {/* </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

EditProfile.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(observer(EditProfile));
